// Copyright (c) 2026 Vigeos SASU. Tous droits réservés.
import React from 'react';
import {
  Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton,
  Paper, Tooltip, Typography,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

/**
 * Mot de passe affiché une seule fois.
 *
 * Le dialogue ne se ferme pas au clic hors cadre ni à Échap : un mot de passe
 * perdu par mégarde ne se rejoue pas, il faudrait passer par la
 * réinitialisation côté client.
 */
export default function DialogueSecret({ secret, onFermer: onClose, onCopier }) {
  return (
    <Dialog open={!!secret} disableEscapeKeyDown maxWidth="sm" fullWidth>
      <DialogTitle>Compte de direction créé</DialogTitle>
      <DialogContent dividers>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Ce mot de passe ne sera plus jamais affiché, ni par cet écran ni par
          l&apos;API. Notez-le maintenant et transmettez-le à la direction par un canal
          distinct de sa boîte mail. Il devra être changé à la première connexion.
        </Alert>
        {secret?.contexte && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {secret.contexte}
          </Typography>
        )}
        <Typography variant="caption" color="text.secondary">Identifiant</Typography>
        <Paper variant="outlined" sx={{ p: 1.5, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography sx={{ fontFamily: 'monospace', flex: 1, wordBreak: 'break-all' }}>
            {secret?.email}
          </Typography>
          <Tooltip title="Copier l'identifiant">
            <IconButton size="small" onClick={() => secret && onCopier(secret.email, "L'identifiant")}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Paper>
        <Typography variant="caption" color="text.secondary">Mot de passe provisoire</Typography>
        <Paper variant="outlined" sx={{ p: 1.5, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography sx={{ fontFamily: 'monospace', fontSize: '1.1rem', letterSpacing: 1, flex: 1, wordBreak: 'break-all' }}>
            {secret?.motDePasse}
          </Typography>
          <Tooltip title="Copier le mot de passe">
            <IconButton size="small" onClick={() => secret && onCopier(secret.motDePasse, 'Le mot de passe')}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Paper>
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 2 }}>
          Connexion sur gestion.vigeos.fr.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          J&apos;ai noté le mot de passe
        </Button>
      </DialogActions>
    </Dialog>
  );
}
